module.exports = __webpack_public_path__ + "static/media/iconScheduleActive.ed6a9e41.svg";